import AlbumMembershipGroup from './AlbumMembershipGroup';

export default AlbumMembershipGroup;
